var map = {
	"./feature_buy_en.png": "4c16",
	"./feature_buy_id.png": "5391",
	"./feature_buy_my.png": "6cf4",
	"./feature_buy_ph.png": "2a17",
	"./feature_buy_th.png": "038c",
	"./feature_buy_zh.png": "c74a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbfc";